import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/logo.svg'


const _withScopeId = n => (_pushScopeId("data-v-30cc60e7"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "service-info d-flex flex-column align-center" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "Логотип"
}, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "text-h5 text-center font-weight-bold" }, "ИС", -1))

import { refObservableValue, showCredits } from '../common'
import { GreeterPage } from '../components'

export default /*#__PURE__*/_defineComponent({
  __name: 'EmptyWebLayout',
  props: {
    desktopMode: { type: Boolean }
  },
  setup(__props: any) {

const props = __props;


const showCreditsRef = refObservableValue(showCredits)

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_main = _resolveComponent("v-main")!

  return (_openBlock(), _createBlock(_component_v_main, { class: "main" }, {
    default: _withCtx(() => [
      (_unref(showCreditsRef))
        ? (_openBlock(), _createBlock(_unref(GreeterPage), {
            key: 0,
            class: "bg",
            "desktop-mode": props.desktopMode
          }, null, 8, ["desktop-mode"]))
        : _createCommentVNode("", true),
      _createVNode(_component_v_container, {
        class: "container d-flex flex-column align-center justify-center",
        style: {"max-width":"1200px"}
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _hoisted_2,
            _hoisted_3,
            _createElementVNode("h5", {
              class: _normalizeClass([{ 'white-title': _unref(showCreditsRef) }, "title text-h5 text-center mb-8 font-weight-bold"])
            }, " «Учет идентификационных карт» ", 2)
          ]),
          (!(_unref(showCreditsRef) && props.desktopMode))
            ? (_openBlock(), _createBlock(_component_router_view, { key: 0 }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})